/*
  Mobile PDP floating cart + "Added to cart" toast (snippets/pdp-floating-cart.liquid).
  - aiza:cart:updated (assets/custom.js, after every cart update) carries the new
    item count for the badge.
  - aiza:cart:toast (assets/custom.js, after the main PDP Add to Cart) shows the
    toast for a few seconds. With detail.inDrawer it is moved into the cart
    drawer that custom.js has just opened, under the drawer header, and hidden
    early if the drawer closes; otherwise it floats over the page as before.
  The count is also re-read from /cart.js whenever the cart drawer closes, so
  quantity changes made inside the drawer by other code paths are picked up too.
*/
(function () {
  var TOAST_MS = 3000;
  // The cart drawer's slide-in (--drawer-transition: transform 0.4s); the
  // in-drawer toast waits for it, so the drawer opens first and the toast
  // follows instead of both arriving at once.
  var DRAWER_SLIDE_MS = 400;
  // Matches the toast's own transition in pdp-floating-cart.css.
  var TOAST_ANIM_MS = 300;

  function init() {
    var button = document.querySelector('[data-pdp-floating-cart]');
    var count = document.querySelector('[data-pdp-floating-cart-count]');
    var toast = document.querySelector('[data-pdp-cart-toast]');
    var hideTimer = null;
    var showTimer = null;
    var drawerWasOpen = document.body.classList.contains('js-drawer-open-cart');
    var drawerOpenedAt = 0;

    function setCount(itemCount) {
      if (!count || typeof itemCount !== 'number') return;
      count.textContent = itemCount > 99 ? '99+' : String(itemCount);
      count.classList.toggle('is-empty', itemCount === 0);
    }

    function hideToast() {
      if (!toast) return;
      clearTimeout(hideTimer);
      clearTimeout(showTimer);
      toast.classList.remove('is-visible');
      setTimeout(function () {
        if (!toast.classList.contains('is-visible')) toast.hidden = true;
      }, TOAST_ANIM_MS);
    }

    // How long until the drawer has finished sliding in. custom.js dispatches
    // aiza:cart:toast right after opening it, before the MutationObserver
    // below has seen the open, so "open now but not yet seen" means "just
    // opened"; a drawer that was already open needs no wait.
    function drawerSlideRemaining() {
      if (!document.body.classList.contains('js-drawer-open-cart')) return 0;
      if (!drawerWasOpen) return DRAWER_SLIDE_MS;
      return Math.max(0, DRAWER_SLIDE_MS - (Date.now() - drawerOpenedAt));
    }

    // Just below the header while it's on screen; the header hides on scroll,
    // and then the toast sits at the top of the screen instead.
    function placeToast() {
      var header = document.querySelector('[data-site-header]');
      var headerBottom = header ? header.getBoundingClientRect().bottom : 0;
      toast.style.top = Math.max(headerBottom, 0) + 12 + 'px';
    }

    // The drawer's markup is re-rendered on every cart update (custom.js), so
    // the toast is (re)inserted each time, after that render. It goes just
    // under the drawer header, in the flow of the drawer.
    function moveToastIntoDrawer() {
      var drawer = document.getElementById('cart-drawer');
      if (!drawer) return false;
      var head = drawer.querySelector('.cart-drawer__head');
      if (head) {
        head.insertAdjacentElement('afterend', toast);
      } else {
        drawer.insertAdjacentElement('afterbegin', toast);
      }
      toast.classList.add('pdp-cart-toast--drawer');
      toast.style.top = '';
      return true;
    }

    function moveToastToPage() {
      if (toast.parentElement !== document.body) document.body.appendChild(toast);
      toast.classList.remove('pdp-cart-toast--drawer');
    }

    function revealToast() {
      toast.hidden = false;
      // Next frame, so the transition runs from the hidden state.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          toast.classList.add('is-visible');
        });
      });
      hideTimer = setTimeout(hideToast, TOAST_MS + TOAST_ANIM_MS);
    }

    function showToast(e) {
      if (!toast) return;
      clearTimeout(hideTimer);
      clearTimeout(showTimer);
      toast.classList.remove('is-visible');
      toast.hidden = true;
      var inDrawer = Boolean(e && e.detail && e.detail.inDrawer) && moveToastIntoDrawer();
      if (inDrawer) {
        // Drawer first, then the toast.
        showTimer = setTimeout(revealToast, drawerSlideRemaining());
      } else {
        moveToastToPage();
        placeToast();
        revealToast();
      }

      if (button) {
        button.classList.add('is-bumped');
        setTimeout(function () {
          button.classList.remove('is-bumped');
        }, 200);
      }
    }

    document.addEventListener('aiza:cart:updated', function (e) {
      setCount(e.detail && e.detail.itemCount);
    });

    document.addEventListener('aiza:cart:toast', showToast);

    // "View cart" opens the drawer (assets/custom.js handles .dev_cart_icon_click);
    // the toast goes away with it.
    if (toast) {
      toast.addEventListener('click', function (e) {
        if (e.target.closest('.dev_cart_icon_click')) {
          clearTimeout(hideTimer);
          hideToast();
        }
      });
    }

    new MutationObserver(function () {
      var drawerOpen = document.body.classList.contains('js-drawer-open-cart');
      if (!drawerWasOpen && drawerOpen) drawerOpenedAt = Date.now();
      if (drawerWasOpen && !drawerOpen) {
        if (toast && toast.classList.contains('pdp-cart-toast--drawer')) hideToast();
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            setCount(cart.item_count);
          })
          .catch(function () {});
      }
      drawerWasOpen = drawerOpen;
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
